module.exports = __webpack_public_path__ + "img/rustore.d9c3059e.svg";